import { Pipe, PipeTransform } from '@angular/core'
import { LocaleService } from '../services/locale/locale-service'
/**
 * locale 번역 pipe
 */
@Pipe({
  name: 'locale',
})
export class LocalePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(value: string | undefined, type: 'text' | 'src' | 'link' | 'parsed' = 'text', param?: string): string {
    if (value === undefined) return ''
    if (type === 'text') {
      return this.localeService.getLocaleString(value, { en: param })
    }
    if (type === 'src') {
      return this.localeService.getLocaleSrc(value)
    }
    if (type === 'link') {
      return this.localeService.getLocaleUrl(value)
    }
    if (type === 'parsed') {
      return this.localeService.getParsedLocaleString(param ?? '', value)
    }
    return value
  }
}
